/* eslint-disable react/prop-types */
import React from 'react';
import { translatableText } from '../../utils/translatable-text';
// @ts-ignore
import { CardWithCEM } from '../card';
import { TopicReference } from '../sidebar/sidebar.types';
import camelCase from 'lodash/camelCase';
import { type ParentPageType } from '../../utils/parent-page-type';

interface CardsProps {
    cards: TopicReference[];
    parentPageType: ParentPageType;
}

const Cards: React.FC<CardsProps> = ({ cards }) => {
    return (
        <>
            {cards.map((item: TopicReference, index: number) => (
                <CardWithCEM
                    tooltipContent={translatableText.editThisTopic.text}
                    key={item.id}
                    id={item.id}
                    title={item.title}
                    description={item.description}
                    buttonText={translatableText.viewTopic.text}
                    buttonLink={item.url}
                    analytics={camelCase(item.title)}
                    entryId={item.id}
                    position={index}
                    parentPageType
                />
            ))}
        </>
    );
};

export default Cards;
